"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotorTruckCargoSteps = exports.MtcSteps = exports.eMotorTruckCargoSteps = void 0;
const policy_1 = require("../policy");
const motorTruckCargo_class_1 = __importDefault(require("./motorTruckCargo.class"));
var eMotorTruckCargoSteps;
(function (eMotorTruckCargoSteps) {
    eMotorTruckCargoSteps["VERIFY_DETAILS"] = "verifyDetails";
    eMotorTruckCargoSteps["COMMODITIES_AND_PROTECTION"] = "commoditiesAndProtection";
    eMotorTruckCargoSteps["SUPPLEMENTAL_COVERAGES"] = "supplementalCoverages";
    eMotorTruckCargoSteps["OPTIONAL_ENDORSEMENTS"] = "optionalEndorsements";
    eMotorTruckCargoSteps["SUMMARY"] = "summary";
})(eMotorTruckCargoSteps = exports.eMotorTruckCargoSteps || (exports.eMotorTruckCargoSteps = {}));
class MtcSteps {
    constructor(data) {
        this.verifyDetails = data.verifyDetails;
        this.commoditiesAndProtection = data.commoditiesAndProtection;
        this.supplementalCoverages = data.supplementalCoverages;
        this.optionalEndorsements = data.optionalEndorsements;
    }
    static fromObj(data) {
        if (!data) {
            return MtcSteps.empty();
        }
        return new MtcSteps(data);
    }
    static empty() {
        return new MtcSteps({
            verifyDetails: policy_1.StepInformation.fromObj({ valid: true }),
            commoditiesAndProtection: policy_1.StepInformation.fromObj({ valid: false }),
            supplementalCoverages: policy_1.StepInformation.fromObj({ valid: false }),
            optionalEndorsements: policy_1.StepInformation.fromObj({ valid: false })
        });
    }
}
exports.MtcSteps = MtcSteps;
class MotorTruckCargoSteps {
    constructor(data) {
        this.verifyDetails = data.verifyDetails;
        this.commoditiesAndProtection = data.commoditiesAndProtection;
        this.supplementalCoverages = data.supplementalCoverages;
        this.optionalEndorsements = data.optionalEndorsements;
    }
    static fromObj(data) {
        if (!data) {
            return MotorTruckCargoSteps.empty();
        }
        return new MotorTruckCargoSteps(data);
    }
    static empty() {
        return new MotorTruckCargoSteps({
            verifyDetails: policy_1.StepInformation.fromObj({ valid: true }),
            commoditiesAndProtection: policy_1.StepInformation.fromObj({ valid: false }),
            supplementalCoverages: policy_1.StepInformation.fromObj({ valid: false }),
            optionalEndorsements: policy_1.StepInformation.fromObj({ valid: false })
        });
    }
}
exports.MotorTruckCargoSteps = MotorTruckCargoSteps;
__exportStar(require("./mtcSteps/verifyDetails"), exports);
__exportStar(require("./mtcSteps/commoditiesAndProtection"), exports);
__exportStar(require("./mtcSteps/endorsements"), exports);
__exportStar(require("./mtcSteps/supplementalCoverages"), exports);
__exportStar(require("./mtcRequest"), exports);
exports.default = motorTruckCargo_class_1.default;
//# sourceMappingURL=index.js.map